import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const DepositEmployerIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <rect x="10.2835" y="17.4473" width="36.813" height="26.3837" rx="2.9465" stroke="black"/>
      <path d="M22.6393 18.6705V15.3916C22.6393 14.7824 23.1331 14.2886 23.7423 14.2886H33.6379C34.2471 14.2886 34.7409 14.7824 34.7409 15.3916V18.6705" stroke="black"/>
      <rect x="18.2065" y="28.208" width="3.23795" height="5.39652" rx="1.61898" fill="black" strokeWidth="0" />
      <rect x="35.5356" y="28.208" width="3.23795" height="5.39652" rx="1.61898" fill="black" strokeWidth="0" />
      <path d="M13.23 17.4473H44.15C45.7773 17.4473 47.0965 18.7665 47.0965 20.3938V23.4742C47.0965 27.005 44.2343 29.8672 40.7035 29.8672H16.6765C13.1457 29.8672 10.2835 27.005 10.2835 23.4742V20.3938C10.2835 18.7665 11.6027 17.4473 13.23 17.4473Z" fill="#BA8235" stroke="black"/>
    </SvgIcon>
  );
};

export default DepositEmployerIcon;
